import { useState, useEffect, useMemo, useCallback } from 'react';
import { Modal } from 'antd';
import { useDropzone } from 'react-dropzone';
import { useNavigate } from 'react-router';
import Upload from '../../assets/icons/Upload';
import HighlightOff from '../../assets/icons/HighlightOff';
import HighlightOff2 from '../../assets/icons/HighlightOff2';
import DashboardHeader from '../../components/DashboardHeader/DashboardHeader';
import Button from '../../components/Button/Button';
import { toast } from 'react-hot-toast';

import { Editor } from 'react-draft-wysiwyg';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState } from 'draft-js';

import { contentTypes, durationTypes, currencyTypes } from '../../data';

import Text from '../../assets/icons/Text';
import RightArrow from '../../assets/icons/RightArrow';
import ThumbsUp from '../../assets/icons/ThumbsUp';
import ThumbsDown from '../../assets/icons/ThumbsDown';
import { getLanguages } from '../../services/schoolService';
import * as services from '../../services/learnService';
import Notif from '../../assets/icons/Notif';
import {
  handlerCourseBannerUpload,
  handlerTeaserUpload,
} from '../../services/handleImage';
import Video from '../../assets/icons/Video';
import ContentUpload from './ContentUpload';
import Publish from '../../assets/icons/Publish';
import Delete from '../../assets/icons/Delete';
import HighlightCheck from '../../assets/icons/HighlightCheck';
import Image from '../../assets/icons/Image';

const AddCourse = () => {
  const navigate = useNavigate();
  let { school } = JSON.parse(localStorage.getItem('userData'));
  let subjectClassId = localStorage.getItem('subjectClass');

  const [active, setActive] = useState(
    subjectClassId ? 'topic-content' : 'information'
  );

  const [progress, setProgress] = useState(0);
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [topic, setTopic] = useState({});
  const [lessonTitle, setLessonTitle] = useState('');
  const [lessons, setLessons] = useState([]);
  const [contentType, setContentType] = useState('');
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [pickContentType, setPickContentType] = useState(false);
  const [classType, setClassType] = useState('group');
  const [durationType, setDurationtype] = useState('Days');
  const [selectedSubjectClass, setSelectedSubjectClass] = useState('');
  const [currency, setCurrency] = useState(school?.currency);
  const [teacherLed, setTeacherLed] = useState(false);
  const [learningOutcomes, setLearningOutcomes] = useState(['', '', '', '']);
  const [dropdowns, setDropdowns] = useState({
    duration: false,
    currency: false,
    language: false,
    subject: false,
  });
  const [details, setDetails] = useState({
    languages: [],
    subjectClasses: [],
  });
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [updateData, setUpdateData] = useState({
    duration: '',
    price: '',
    title: '',
    description: '',
  });
  const [videoUrl, setVideoUrl] = useState('');
  const [bannerUrl, setBannerUrl] = useState('');
  const [file, setFile] = useState('');
  const [bannerfile, setBannerFile] = useState('');
  const [topicSaved, setTopicSaved] = useState(false);
  const [lessonCount, setLessonCount] = useState(0);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [cancelVisible, setCancelVisible] = useState(false);

  useEffect(() => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    const getDetails = async () => {
      let res = await getLanguages();
      let resSubjects = await services.getSubjectClasses(school?.id);

      setDetails({
        ...details,
        languages: res.data.languages,
        subjectClasses: resSubjects.data.school.subjectClasses,
      });
    };

    getDetails();
  }, []);

  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
  };

  const handleLearningOutcomeChange = (index, value) => {
    const newLearningOutcomes = [...learningOutcomes];
    newLearningOutcomes[index] = value;
    setLearningOutcomes(newLearningOutcomes);
  };

  const saveUnit = () => {
    setLessons([topic, ...lessons]);
  };

  const resetDropdown = () => {
    setDropdowns({
      duration: false,
      currency: false,
    });
  };

  const saveLessonType = (id) => {
    for (const obj of lessons) {
      obj.lessonContent = [];
      if (obj.id === id) {
        obj.lessonContent.push(...lessons.lessonContent, {
          contentType: contentType.toLowerCase(),
          content: editorState.getCurrentContent().getPlainText(),
        });
        setContentType('');
        break;
      }
    }
  };

  const saveLessonTitle = (id) => {
    for (const obj of lessons) {
      if (obj.id === id) {
        obj.lessonTitle = lessonTitle;
        setLessons([...lessons]);
        break;
      }
    }
  };

  //close modal
  const handleCancel = () => {
    setConfirmVisible(false);
    setCancelVisible(false);
  };

  //upload video on drop
  const onDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      toast.error('Please a upload a valid video format');
      return;
    }

    // if (acceptedFiles[0].size > 100345000) {
    //   notification['error']({
    //     message: 'Please a upload a video less than 100mb',
    //   });
    //   return;
    // }
    setFile(acceptedFiles[0]);

    setVideoUrl(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const onImageDrop = useCallback(async (acceptedFiles) => {
    if (acceptedFiles.length === 0) {
      toast.error('Please a upload a valid image');
      return;
    }

    setBannerFile(acceptedFiles[0]);
    setBannerUrl(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const uploadFile = async (courseId) => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    try {
      setUploading(true);
      let res = await handlerTeaserUpload(
        file,
        school?.id,
        courseId,
        (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        }
      );
      toast.success('Teaser uploaded successfully');
      setUploading(false);
      setActive('topic-content');
    } catch (error) {
      setUploading(false);
      console.log(error);
      toast.error(error.response?.data?.data?.errors?.teaser[0]);
    }
  };

  const uploadCourseBanner = async (courseId) => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    try {
      setUploading(true);
      let res = await handlerCourseBannerUpload(
        bannerfile,
        school?.id,
        courseId,
        (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total));
        }
      );
      toast.success('Banner uploaded successfully');
      setUploading(false);
      setActive('topic-content');
    } catch (error) {
      setUploading(false);
      console.log(error);
      toast.error(error.response?.data?.data?.errors?.banner[0]);
    }
  };

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    borderColor: '#eeeeee',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%',
  };

  const focusedStyle = {
    borderColor: '#2196f3',
  };

  const acceptStyle = {
    borderColor: '#00e676',
  };

  const rejectStyle = {
    borderColor: 'red',
  };

  const { getRootProps, getInputProps, isFocused, isDragAccept, isDragReject } =
    useDropzone({
      onDrop,
      accept: 'video/*',
    });

  const {
    getRootProps: getBannerRootProps,
    getInputProps: getBannerInputProps,
  } = useDropzone({
    onDrop: onImageDrop,
    accept: 'image/*',
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isFocused, isDragAccept, isDragReject]
  );

  const handleChange = (evt) => {
    const value = evt.target.value;
    const name = evt.target.name;
    setUpdateData({
      ...updateData,
      [name]: value,
    });
  };

  const handleCheckBox = (e) => {
    setTeacherLed(e.target.checked);
  };

  //create lesson
  const createCourse = async () => {
    if (!file) {
      toast.error('Please upload a preview video');
      return;
    }
    if (!bannerfile) {
      toast.error('Please upload a banner for the course');
      return;
    }
    if (updateData.duration === '0' || updateData.duration.includes('-')) {
      toast.error('Duration cannot be 0 or negative');
      return;
    }
    let { school } = JSON.parse(localStorage.getItem('userData'));
    let data = {
      subjectClass: selectedSubjectClass.id,
      groupClass: classType === 'group' ? true : false,
      duration: updateData.duration,
      teacherLed,
      price: updateData.price,
      language: selectedLanguage.id,
      currency: currency.id,
      learningOutcomes: learningOutcomes.filter((el) => el !== ''),
    };

    try {
      setLoading(true);
      let res = await services.createLesson(school?.id, data);
      localStorage.setItem('course', JSON.stringify(res.data.course));
      localStorage.setItem('subjectClass', selectedSubjectClass.id);
      await uploadFile(res.data.course.id);
      await uploadCourseBanner(res.data.course.id);
      toast.success(res.message);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  //save topic
  const saveTopic = async () => {
    let { school } = JSON.parse(localStorage.getItem('userData'));
    let course = JSON.parse(localStorage.getItem('course'));
    let subjectClassId = localStorage.getItem('subjectClass');

    if (updateData.title === '' || updateData.description === '') {
      toast.error('Fields cannot be empty');
      return;
    }

    let data = {
      title: updateData.title,
      description: updateData.description,
      subjectClass: subjectClassId,
    };
    try {
      setLoading(true);
      let res = await services.createTopic(school?.id, course.id, data);
      toast.success(
        `${res.message}, click on 'add lesson' to add content to the saved topic`
      );

      setTopicSaved(true);
      setLoading(false);
      localStorage.setItem('topic', JSON.stringify(res.data.topic));
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(`An Error Occurred, please try again`);
    }
  };

  const publishLesson = async () => {
    try {
      setLoading(true);
      let res1 = await services.publishCourse();
      let res2 = services.publishTopic();
      let token = localStorage.getItem('token');
      let userData = JSON.parse(localStorage.getItem('userData'));
      localStorage.clear();
      localStorage.setItem('token', token);
      localStorage.setItem('userData', JSON.stringify(userData));
      toast.success(`Course Published Successfully`);
      toast.success(`Topic Published Successfully`);

      setLoading(false);
      navigate('/tutor/courses');
    } catch (error) {
      setLoading(false);
      console.log(error);
      toast.error(
        `An error occured,ensure you have saved title first and try again`
      );
    }
  };

  return (
    <div className='add-course'>
      <DashboardHeader tutor />
      <div className='add-course__breadcrumbs'>
        <div onClick={() => navigate('/tutor-dashboard')}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
              fill='#161410'
            />
          </svg>
        </div>

        <p>
          {' '}
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/tutor-dashboard')}
          >
            Home
          </span>{' '}
          |{' '}
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => navigate('/tutor/courses')}
          >
            Lessons
          </span>{' '}
          | <b style={{ color: '#161410' }}>Create Lessons</b>
        </p>
        <div className='add-course__badge'>
          <svg
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M7.33398 9.99992H8.66732V11.3333H7.33398V9.99992ZM7.33398 4.66659H8.66732V8.66659H7.33398V4.66659ZM7.99398 1.33325C4.31398 1.33325 1.33398 4.31992 1.33398 7.99992C1.33398 11.6799 4.31398 14.6666 7.99398 14.6666C11.6807 14.6666 14.6673 11.6799 14.6673 7.99992C14.6673 4.31992 11.6807 1.33325 7.99398 1.33325ZM8.00065 13.3333C5.05398 13.3333 2.66732 10.9466 2.66732 7.99992C2.66732 5.05325 5.05398 2.66659 8.00065 2.66659C10.9473 2.66659 13.334 5.05325 13.334 7.99992C13.334 10.9466 10.9473 13.3333 8.00065 13.3333Z'
              fill='#E58D10'
            />
          </svg>
          <p>Unpublished</p>
        </div>
      </div>
      <div className='add-course__banner'>
        <div className='add-course__banner__content'>
          <h2>
            {selectedSubjectClass
              ? selectedSubjectClass.title
              : ' Course title'}
          </h2>{' '}
          <p>
            Offered by: <span>{school?.name}</span>
          </p>
        </div>
      </div>
      <div className='add-course__body'>
        <main className='add-course__body__left'>
          <div className='add-course__body__tabs-wrapper'>
            <button
              disabled={topicSaved}
              className={`add-course__body__tabs-wrapper__tab + ${
                active === 'information' && 'tab-active'
              }`}
              onClick={() => setActive('information')}
            >
              {active === 'topic-content' ? (
                <HighlightCheck />
              ) : (
                <HighlightOff />
              )}
              <p className='add-course__body__tabs-wrapper__tab-selected '>
                {' '}
                Subject Information
              </p>
            </button>

            <button
              className={`add-course__body__tabs-wrapper__tab  ${
                active === 'topic-content' && 'tab-active'
              }`}
              onClick={() => {
                if (
                  !updateData.duration ||
                  !updateData.price ||
                  loading ||
                  !selectedSubjectClass.id ||
                  !selectedLanguage.id ||
                  !subjectClassId
                ) {
                  toast.error('Please save subject information first');
                } else {
                  setActive('topic-content');
                }
              }}
            >
              <HighlightOff2 />
              <p className='add-course__body__tabs-wrapper__tab-options'>
                {' '}
                Topic content
              </p>
            </button>
          </div>
          {active === 'information' && (
            <div className='add-course__body__form'>
              <div className='add-course__body__form__title'>
                <h2>Subject Information</h2>
                <p>
                  Tell students more about this subject and its learning
                  outcomes
                </p>
              </div>

              <form>
                <div className='dropdown-wrapper'>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%', marginBottom: '8px' }}
                    onClick={() =>
                      dropdowns.subject
                        ? setDropdowns({ ...dropdowns, subject: false })
                        : setDropdowns({ ...dropdowns, subject: true })
                    }
                  >
                    <label htmlFor='subject'>Class name</label>

                    <input
                      type='text'
                      name='className'
                      disabled
                      id='subject'
                      placeholder='Select the class you want to create topics for?'
                      defaultValue={selectedSubjectClass?.title || ''}
                    />
                    <div className='eye-icon'>
                      <RightArrow />
                    </div>
                  </div>
                  {dropdowns.subject && (
                    <div className='dropdown-wrapper__dropdown'>
                      {details?.subjectClasses?.map((el) => (
                        <div
                          className='dropdown-wrapper__dropdown__item'
                          onClick={() => {
                            setSelectedSubjectClass(el);
                            resetDropdown();
                          }}
                        >
                          <p>{el.title}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className='add-course__body__form__note'>
                    <input type='checkbox' onChange={handleCheckBox} />
                    <p>
                      Check the box if you want students to watch lessons
                      chronologically (i.e teacher led learning)
                    </p>
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>
                    What type of live class is this subject?
                  </label>

                  <div className='flex-to-column'>
                    {' '}
                    <button
                      className='live-class-type'
                      onClick={(e) => {
                        e.preventDefault();
                        setClassType('group');
                      }}
                    >
                      {classType === 'group' ? <ThumbsUp /> : <ThumbsDown />}
                      <p className={classType === 'group' ? 'bold' : 'faint'}>
                        Group Class
                      </p>
                    </button>
                    <button
                      className='live-class-type'
                      onClick={(e) => {
                        e.preventDefault();
                        setClassType('one');
                      }}
                    >
                      {classType === 'one' ? <ThumbsUp /> : <ThumbsDown />}
                      <p className={classType === 'one' ? 'bold' : 'faint'}>
                        One- on- one class
                      </p>
                    </button>
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='subject'>Subject duration</label>
                  <div className='select-input'>
                    <div className='dropdown-wrapper'>
                      <div
                        className='select'
                        // onClick={() => {
                        //   dropdowns.duration
                        //     ? setDropdowns({ ...dropdowns, duration: false })
                        //     : setDropdowns({ ...dropdowns, duration: true });
                        // }}
                      >
                        <p>{durationType}</p>
                        {/* <RightArrow /> */}
                      </div>
                      {dropdowns.duration && (
                        <div className='dropdown-wrapper__dropdown'>
                          {durationTypes.map((el, idx) => (
                            <div
                              className='dropdown-wrapper__dropdown__item'
                              key={idx}
                              onClick={() => {
                                setDurationtype(el);
                                resetDropdown();
                              }}
                            >
                              <p>{el}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type='text'
                      name='duration'
                      id='class'
                      onChange={handleChange}
                      placeholder='Enter number'
                    />
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='price'>
                    How much do you want students to pay for this subject?
                  </label>
                  <div className='select-input'>
                    <div className='dropdown-wrapper'>
                      <div
                        className='select'
                        style={{ width: '178px' }}
                        // onClick={() => {
                        //   dropdowns.duration
                        //     ? setDropdowns({ ...dropdowns, currency: false })
                        //     : setDropdowns({ ...dropdowns, currency: true });
                        // }}
                      >
                        <p>
                          {`${currency?.title} (${currency.symbol})` ||
                            'Nigerian Naira (₦)'}
                        </p>
                        {/* <RightArrow /> */}
                      </div>
                      {dropdowns.currency && (
                        <div className='dropdown-wrapper__dropdown'>
                          {currencyTypes.map((el) => (
                            <div
                              className='dropdown-wrapper__dropdown__item'
                              key={el.id}
                              onClick={() => {
                                setCurrency(el);
                                resetDropdown();
                              }}
                            >
                              <p>{el.title}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type='text'
                      name='price'
                      id='price'
                      placeholder='Enter price'
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {learningOutcomes.map((outcome, index) => (
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                    key={index}
                  >
                    <label htmlFor='subject'>
                      Learning outcome {index + 1}
                    </label>

                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      placeholder='Example; Adhering to forming practices for plant growth'
                      value={outcome}
                      onChange={(e) =>
                        handleLearningOutcomeChange(index, e.target.value)
                      }
                    />
                    <div className='eye-icon'></div>
                    <p
                      style={{
                        fontSize: '12px',
                        marginLeft: 'auto',
                        fontWeight: 300,
                      }}
                    >
                      160 characters
                    </p>
                  </div>
                ))}

                {/* <div className='add-more' style={{ margin: '24px 0' }}>
                  {' '}
                  <svg
                    width='14'
                    height='14'
                    viewBox='0 0 14 14'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z' fill='#FEA82F' />
                  </svg>
                  <p>Add More</p>
                </div> */}

                <div
                  className='dropdown-wrapper'
                  style={{ marginBottom: '24px' }}
                >
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%', marginBottom: '0px' }}
                    onClick={() =>
                      dropdowns.language
                        ? setDropdowns({ ...dropdowns, language: false })
                        : setDropdowns({ ...dropdowns, language: true })
                    }
                  >
                    <label htmlFor='subject'>Language of instruction</label>

                    <input
                      type='text'
                      name='class'
                      id='class'
                      disabled
                      placeholder='Select Language'
                      defaultValue={selectedLanguage?.name}
                    />
                    <div className='eye-icon'>
                      <RightArrow />
                    </div>
                  </div>
                  {dropdowns.language && (
                    <div className='dropdown-wrapper__dropdown'>
                      {details?.languages?.map((el) => (
                        <div
                          className='dropdown-wrapper__dropdown__item'
                          onClick={() => {
                            setSelectedLanguage(el);
                            resetDropdown();
                          }}
                        >
                          <p>{el.name}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='teaser'>
                    Upload a video introducing the expectations and learning
                    outcomes for this subject
                  </label>
                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : videoUrl ? (
                      <>
                        <div className='video-preview'>
                          <video src={videoUrl[0]?.preview}></video>
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Video />
                            </div>
                            <p>{videoUrl[0]?.name}</p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() => setVideoUrl('')}
                        >
                          <Upload />
                          <p>Replace Video</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div {...getRootProps({ style })}>
                          <input {...getInputProps()} />
                          <Upload />
                          <p>Drag and drop video or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div
                  className='auth-wrapper__right__form__inputwrapper eye-position'
                  style={{ width: '100%' }}
                >
                  <label htmlFor='teaser'>
                    Upload a picture to be used as the course banner
                    (Recommended dimension is 370px × 187px)
                  </label>
                  <div className='dropzone-video'>
                    {uploading ? (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <label htmlFor='progress-bar'>{progress}%</label>
                        <progress
                          id='progress-bar'
                          value={progress}
                          max='100'
                        ></progress>
                      </div>
                    ) : bannerUrl ? (
                      <>
                        <div className='video-preview'>
                          <img
                            style={{ width: '100px', height: '50px' }}
                            src={bannerUrl[0]?.preview}
                          />
                          <div className='video-preview__video-details'>
                            <div className='video-preview__video-details__icon'>
                              <Image />
                            </div>
                            <p>{bannerUrl[0]?.name}</p>
                          </div>
                        </div>
                        <div
                          className='replace-vid'
                          onClick={() => setBannerUrl('')}
                        >
                          <Upload />
                          <p>Replace Banner</p>
                        </div>
                      </>
                    ) : (
                      <div className='container'>
                        <div {...getBannerRootProps({ style })}>
                          <input {...getBannerInputProps()} />
                          <Upload />
                          <p>Drag and drop image or </p>
                          <p className='sec-text'> Upload from your computer</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className='notif'>
                  <Notif />
                  <p>All files should be at least 720p and less than 100mb</p>
                </div>
              </form>
            </div>
          )}

          {active === 'topic-content' && (
            <div className='add-course__body__form'>
              <div className='add-course__body__form__title'>
                <h2>Topic Content</h2>
                <p>
                  Enter the title and a description for the topic you want to
                  create lesson for
                </p>
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%' }}
              >
                <label htmlFor='title'>Topic title</label>

                <input
                  type='text'
                  name='title'
                  id='title'
                  placeholder='Create a new topic'
                  onChange={handleChange}
                />
              </div>

              <div
                className='auth-wrapper__right__form__inputwrapper eye-position'
                style={{ width: '100%' }}
              >
                <label htmlFor='description'>
                  Topic description (Maximum of 50 words)
                </label>

                <textarea
                  //maxLength={50}
                  type='text'
                  name='description'
                  id='description'
                  onChange={handleChange}
                  placeholder="Example; Linear algebraic equation made easy is the art and science of cultivating the soil, growing crops and raising livestock. It includes the preparation of plant and animal products for people to use and their distribution to markets. Agriculture provides most of the world's food and fabrics. Agriculture is the art and science of cultivating the soil, growing crops and raising livestock. It includes the preparation of plant and animal products"
                />
              </div>

              {Array(lessonCount)
                .fill(lessonCount)
                .map((el, idx) => (
                  <ContentUpload sn={idx} />
                  // <ContentUploadTesting sn={idx} />
                ))}

              {!lessons ? (
                <div className='add-course__topic-content'>
                  <div
                    className='auth-wrapper__right__form__inputwrapper eye-position'
                    style={{ width: '100%' }}
                  >
                    <label htmlFor='subject'>
                      Unit 1.0 :{' '}
                      {lessons?.lessonTitle
                        ? lessons?.lessonTitle
                        : 'Create lesson'}
                    </label>

                    <input
                      type='text'
                      name='outcome1'
                      id='outcome1'
                      placeholder='Enter a title for this unit'
                      onChange={(e) =>
                        setTopic({
                          id: Math.random(1000),
                          topic: e.target.value,
                        })
                      }
                    />
                    <div className='eye-icon'></div>
                    <p style={{ fontSize: '12px', marginLeft: 'auto' }}>
                      80 characters
                    </p>

                    <button
                      className='orange-border'
                      style={{ marginLeft: 'auto', marginTop: '24px' }}
                      onClick={() => saveUnit()}
                    >
                      Save
                    </button>
                  </div>
                </div>
              ) : (
                lessons.length > 0 &&
                lessons?.map((el, id) => (
                  <>
                    <div className='add-course__topic-content-filled' key={id}>
                      <p className='add-course__topic-content-filled__heading'>
                        <span> Unit {id + 1}.0</span> :{' '}
                        <span style={{ color: '#161410' }}>{el.topic}</span>
                      </p>
                      <div className='add-course__topic-content'>
                        <div
                          className='auth-wrapper__right__form__inputwrapper eye-position'
                          style={{ width: '100%' }}
                        >
                          <label htmlFor='subject'>
                            Lesson 1.0 :{' '}
                            {el?.lessonTitle ? lessonTitle : 'Create lesson'}
                          </label>
                          {el.lessonTitle ? (
                            <div></div>
                          ) : (
                            <>
                              <input
                                type='text'
                                name='outcome1'
                                id='outcome1'
                                placeholder='Enter a title for this lesson'
                                onChange={(e) => setLessonTitle(e.target.value)}
                              />
                              <div className='eye-icon'></div>
                              <p
                                style={{ fontSize: '12px', marginLeft: 'auto' }}
                              >
                                80 characters
                              </p>
                              <button
                                className='orange-border'
                                style={{
                                  marginLeft: 'auto',
                                  marginTop: '24px',
                                }}
                                onClick={() => {
                                  saveLessonTitle(el.id);
                                  setPickContentType(true);
                                }}
                              >
                                Save
                              </button>
                            </>
                          )}
                        </div>

                        {el.lessonContent.map((content) => (
                          <div className='add-course__content-list'>
                            <div className='add-course__content-list__left'>
                              <div className='add-course__content-list__left__icon'>
                                <Text />
                              </div>
                              <div>
                                <div className='add-course__content-list__left__content-name'>
                                  <div className='add-course__content-selection__row__selection-item__icon-bg'>
                                    <Text />
                                  </div>
                                  <p className='add-course__content-list__left__content-name__title'>
                                    {content.content}
                                  </p>
                                </div>
                                <p>0 : 00</p>
                              </div>
                            </div>

                            <div className='add-course__content-list__right'>
                              <p>Preview</p>
                            </div>
                          </div>
                        ))}
                        <div
                          className='add-more'
                          style={{ marginTop: '24px' }}
                          onClick={() => setPickContentType(true)}
                        >
                          {' '}
                          <svg
                            width='14'
                            height='14'
                            viewBox='0 0 14 14'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z'
                              fill='#FEA82F'
                            />
                          </svg>
                          <p>Add content</p>
                        </div>
                        {pickContentType && (
                          <>
                            <div
                              className='add-course__content-selection'
                              style={{ marginBottom: '32px' }}
                            >
                              <label className='add-course__content-selection__head'>
                                <p className='add-course__content-selection__head__title'>
                                  {' '}
                                  What type of content do you want to add to
                                  this lesson?
                                </p>

                                <p className='add-course__content-selection__head__action'>
                                  Cancel
                                </p>
                              </label>
                              <div className='add-course__content-selection__row'>
                                {contentTypes.map((el) => (
                                  <div
                                    className='add-course__content-selection__row__selection-item'
                                    onClick={() => {
                                      setContentType(el.content);
                                      setPickContentType(false);
                                    }}
                                    key={el.id}
                                  >
                                    <div className='add-course__content-selection__row__selection-item__icon-bg'>
                                      {el.icon}
                                    </div>

                                    <p style={{ color: '#161410' }}>
                                      {el.content}
                                    </p>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </>
                        )}
                        {contentType.toLowerCase() === 'text' && (
                          <div className='add-course__content-wrap'>
                            <p
                              className='add-course__content-selection__head__title'
                              style={{ marginBottom: '16px' }}
                            >
                              Add text
                            </p>
                            <div className='add-course__text-editor'>
                              <Editor
                                editorState={editorState}
                                wrapperClassName='demo-wrapper'
                                editorClassName='demo-editor'
                                onEditorStateChange={onEditorStateChange}
                                toolbar={{
                                  options: [
                                    'inline',
                                    'blockType',
                                    'fontSize',
                                    'fontFamily',
                                  ],
                                  inline: {
                                    options: ['bold', 'italic', 'underline'],
                                    bold: {
                                      className: 'bordered-option-classname',
                                    },
                                    italic: {
                                      className: 'bordered-option-classname',
                                    },
                                    underline: {
                                      className: 'bordered-option-classname',
                                    },
                                    strikethrough: {
                                      className: 'bordered-option-classname',
                                    },
                                    code: {
                                      className: 'bordered-option-classname',
                                    },
                                  },
                                  blockType: {
                                    className: 'bordered-option-classname',
                                  },
                                  fontSize: {
                                    className: 'bordered-option-classname',
                                  },
                                  fontFamily: {
                                    className: 'bordered-option-classname',
                                  },
                                }}
                              />
                            </div>
                            <div className='add-course__text-editor__cancel'>
                              <p> Cancel</p>
                              <Button
                                text={`Add ${contentType}`}
                                className='orange-border'
                                onClick={() => saveLessonType(el.id)}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className='add-more' style={{ marginTop: '24px' }}>
                        {' '}
                        <svg
                          width='14'
                          height='14'
                          viewBox='0 0 14 14'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z'
                            fill='#FEA82F'
                          />
                        </svg>
                        <p>Add another lesson</p>
                      </div>
                    </div>
                  </>
                ))
              )}
              <div
                className='add-more'
                style={{ marginTop: '24px' }}
                onClick={() => {
                  if (!topicSaved) {
                    toast.error('Please save topic and description first');
                  } else setLessonCount(lessonCount + 1);
                }}
              >
                {' '}
                <svg
                  width='14'
                  height='14'
                  viewBox='0 0 14 14'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path d='M14 8H8V14H6V8H0V6H6V0H8V6H14V8Z' fill='#FEA82F' />
                </svg>
                <p>Add Lesson</p>
              </div>
            </div>
          )}
        </main>

        <div className='content-details'>
          <div className='content-details__item'>
            <div className='content-details__item__icon-wrapper'>
              <svg
                width='34'
                height='34'
                viewBox='0 0 34 34'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM16.9997 30.3335C9.63301 30.3335 3.66634 24.3668 3.66634 17.0002C3.66634 9.6335 9.63301 3.66683 16.9997 3.66683C24.3663 3.66683 30.333 9.6335 30.333 17.0002C30.333 24.3668 24.3663 30.3335 16.9997 30.3335ZM17.833 8.66683H15.333V18.6668L24.083 23.9168L25.333 21.8668L17.833 17.4168V8.66683Z'
                  fill='#5A5955'
                />
              </svg>
            </div>
            <div className='content-details__item__text'>
              <h3>Duration</h3>
              <p>Estimated weeks to complete</p>
            </div>
          </div>

          <div className='content-details__item'>
            <div className='content-details__item__icon-wrapper'>
              <svg
                width='40'
                height='41'
                viewBox='0 0 40 41'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g clipPath='url(#clip0_1750_8431)'>
                  <path
                    d='M31.6667 8.53752V32.4423H8.33333V8.53752H31.6667ZM31.6667 5.12256H8.33333C6.5 5.12256 5 6.65929 5 8.53752V32.4423C5 34.3205 6.5 35.8572 8.33333 35.8572H31.6667C33.5 35.8572 35 34.3205 35 32.4423V8.53752C35 6.65929 33.5 5.12256 31.6667 5.12256Z'
                    fill='#5A5955'
                  />
                  <path
                    d='M23.3337 29.027H11.667V25.612H23.3337V29.027ZM28.3337 22.197H11.667V18.7821H28.3337V22.197ZM28.3337 15.3671H11.667V11.9521H28.3337V15.3671Z'
                    fill='#5A5955'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_1750_8431'>
                    <rect width='40' height='40.9796' fill='white' />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className='content-details__item__text'>
              <h3>Topics</h3>
              <p>0 Topics</p>
            </div>
          </div>

          <div className='content-details__item'>
            <div className='content-details__item__icon-wrapper'>
              <svg
                width='34'
                height='34'
                viewBox='0 0 34 34'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M16.983 0.333496C7.78301 0.333496 0.333008 7.80016 0.333008 17.0002C0.333008 26.2002 7.78301 33.6668 16.983 33.6668C26.1997 33.6668 33.6663 26.2002 33.6663 17.0002C33.6663 7.80016 26.1997 0.333496 16.983 0.333496ZM28.533 10.3335H23.6163C23.083 8.25016 22.3163 6.25016 21.3163 4.40016C24.383 5.45016 26.933 7.5835 28.533 10.3335ZM16.9997 3.7335C18.383 5.7335 19.4663 7.95016 20.183 10.3335H13.8163C14.533 7.95016 15.6163 5.7335 16.9997 3.7335ZM4.09967 20.3335C3.83301 19.2668 3.66634 18.1502 3.66634 17.0002C3.66634 15.8502 3.83301 14.7335 4.09967 13.6668H9.73301C9.59967 14.7668 9.49967 15.8668 9.49967 17.0002C9.49967 18.1335 9.59967 19.2335 9.73301 20.3335H4.09967ZM5.46634 23.6668H10.383C10.9163 25.7502 11.683 27.7502 12.683 29.6002C9.61634 28.5502 7.06634 26.4335 5.46634 23.6668ZM10.383 10.3335H5.46634C7.06634 7.56683 9.61634 5.45016 12.683 4.40016C11.683 6.25016 10.9163 8.25016 10.383 10.3335ZM16.9997 30.2668C15.6163 28.2668 14.533 26.0502 13.8163 23.6668H20.183C19.4663 26.0502 18.383 28.2668 16.9997 30.2668ZM20.8997 20.3335H13.0997C12.9497 19.2335 12.833 18.1335 12.833 17.0002C12.833 15.8668 12.9497 14.7502 13.0997 13.6668H20.8997C21.0497 14.7502 21.1663 15.8668 21.1663 17.0002C21.1663 18.1335 21.0497 19.2335 20.8997 20.3335ZM21.3163 29.6002C22.3163 27.7502 23.083 25.7502 23.6163 23.6668H28.533C26.933 26.4168 24.383 28.5502 21.3163 29.6002ZM24.2663 20.3335C24.3997 19.2335 24.4997 18.1335 24.4997 17.0002C24.4997 15.8668 24.3997 14.7668 24.2663 13.6668H29.8997C30.1663 14.7335 30.333 15.8502 30.333 17.0002C30.333 18.1502 30.1663 19.2668 29.8997 20.3335H24.2663Z'
                  fill='#5A5955'
                />
              </svg>
            </div>
            <div className='content-details__item__text'>
              <h3>Language</h3>
              <p>English</p>
            </div>
          </div>
          {active === 'topic-content' && topicSaved && (
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}
            >
              <Button
                text={loading ? 'Publishing...' : 'Publish Course'}
                className='primary-btn'
                width='100%'
                disabled={loading || !subjectClassId}
                onClick={() => setConfirmVisible(true)}
              />

              <Button
                text='Preview'
                className='orange-border'
                width='100%'
                onClick={() => {
                  let topic = JSON.parse(localStorage.getItem('topic'));
                  window.open(`/tutor/courses/${topic.id}`, '_blank');
                }}
              />
            </div>
          )}
        </div>
      </div>
      <footer className='add-course__footer'>
        {active === 'topic-content' ? (
          <div className='add-course__footer__btn-group'>
            <svg
              width='18'
              height='12'
              viewBox='0 0 18 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                fill='#161410'
              />
            </svg>
            <p>Back</p>
          </div>
        ) : (
          <div
            className='add-course__footer__btn-group'
            style={{ visibility: 'hidden' }}
          >
            <svg
              width='18'
              height='12'
              viewBox='0 0 18 12'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M18 5H3.83L7.41 1.41L6 0L0 6L6 12L7.41 10.59L3.83 7H18V5Z'
                fill='#161410'
              />
            </svg>
            <p>Back</p>
          </div>
        )}

        <div style={{ display: 'flex', gap: '24px' }}>
          <Button
            text={'Cancel'}
            className='cancel-btn'
            onClick={() => setCancelVisible(true)}
          />
          {active === 'topic-content' ? (
            <Button
              text={
                <p style={{ color: '#161410' }}>
                  {loading
                    ? 'Please Wait...'
                    : topicSaved
                    ? 'Save & publish'
                    : 'Save'}
                </p>
              }
              className='primary-btn'
              onClick={() =>
                topicSaved ? setConfirmVisible(true) : saveTopic()
              }
              disabled={loading}
            />
          ) : (
            <Button
              text={
                <div
                  style={{ display: 'flex', gap: '11px', alignItems: 'center' }}
                >
                  <p style={{ color: '#161410' }}>Save and Next</p>
                  <svg
                    width='18'
                    height='13'
                    viewBox='0 0 18 13'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M0 7.03613L14.17 7.03613L10.59 10.6261L12 12.0361L18 6.03613L12 0.0361328L10.59 1.44613L14.17 5.03613L0 5.03613V7.03613Z'
                      fill='#161410'
                    />
                  </svg>
                </div>
              }
              disabled={
                !updateData.duration ||
                !updateData.price ||
                loading ||
                !selectedSubjectClass.id ||
                !selectedLanguage.id ||
                videoUrl === '' ||
                bannerUrl === ''
              }
              className='primary-btn'
              onClick={() => createCourse()}
            />
          )}
        </div>
      </footer>
      <Modal
        width={606}
        visible={confirmVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Publish />
            </div>
            <h2>Publish topic?</h2>
            <p style={{ marginBottom: '32px' }}>
              Are you sure you want to publish this topic
            </p>
            <Button
              text={'Yes'}
              className='w-full'
              onClick={() => publishLesson()}
            />
            <p style={{ marginTop: '32px' }} onClick={() => handleCancel()}>
              Cancel
            </p>
          </div>
        </div>
      </Modal>

      <Modal
        width={606}
        visible={cancelVisible}
        onOk={handleCancel}
        onCancel={handleCancel}
        footer={null}
      >
        <div style={{ padding: '40px' }}>
          <div className='modal-head' style={{ marginBottom: '32px' }}>
            <div className='confirm-icon-wrapper'>
              <Delete />
            </div>
            <h2>Cancel Lesson?</h2>
            <p style={{ marginBottom: '32px' }}>
              Are you sure you want to cancel this lesson creation?
            </p>
            <Button
              text={'Yes'}
              className='w-full'
              onClick={() => navigate(-1)}
            />
            <p style={{ marginTop: '32px' }} onClick={() => handleCancel()}>
              Cancel
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddCourse;
